// extracted by mini-css-extract-plugin
export default {"title":"ExerciseTitle_title__NXvEL"};